import React, { Component } from 'react'
import i18n from 'live/services/i18n'
import DateService from 'live/services/date'
import TimeRange from 'live/components/ui/time-range'
import DashboardLink from 'live/components/ui/DashboardLink'
import DefaultAnnotationActions from './annotation-default-actions'

type Event = {
    author?: string
    message?: string
    __color?: string
    createdAt?: number
    begin?: number
    end?: number
}
type Props = {
    expanded?: boolean
    onClick?: (event: Event) => void
    mode?: string
    event?: Event
}

class DefaultAnnotation extends Component<Props> {
    getMessagePreview(message, length = 90) {
        if (!message || typeof message !== 'string') return ''

        return `${message.substr(0, length)}${message.length > length ? '...' : ''}`
    }

    render() {
        const now = new Date()
        const nowTime = now.getTime()

        const { onClick, event, expanded, mode, dashboardId, dateTimeFormatter } = this.props
        const { message, dashboard, author, createdAt = now, __color, begin = nowTime, end } = event
        const mCreatedAt = DateService.getMoment(createdAt)
        const dashboardSpan = event.dashboardSpan && `${event.dashboardSpan} shifted to ts ${event.createdAt}`

        return (
            <div
                onClick={expanded ? null : () => onClick(event)}
                className={`live-annotation ${expanded ? 'live-annotation--expanded' : ''}`}
            >
                <div className="live-annotation__title">{i18n('Note')}</div>
                {expanded ? <DefaultAnnotationActions {...this.props} /> : null}

                <div className="live-annotation__subtitle">
                    {i18n('by')}{' '}
                    <span className="live-annotation__author">
                        <small>{author || i18n('Missing author')}</small>
                    </span>
                    {', '}
                    <span
                        className="live-annotation__note-time"
                        title={mCreatedAt.format(DateService.getDateTimeFormat())}
                    >
                        {typeof dateTimeFormatter === 'function'
                            ? dateTimeFormatter(createdAt)
                            : DateService.fromNowCalendar(createdAt)}
                    </span>
                    {dashboard && !dashboardId ? (
                        <span>
                            {` ${i18n('on')} `}
                            <DashboardLink
                                name={event.dashboard}
                                id={event.dashboardId}
                                filters={event.dashboardFilters}
                                span={dashboardSpan}
                                begin={event.begin}
                                end={event.end}
                            />
                        </span>
                    ) : null}
                </div>
                <div className="live-annotation__time-range">
                    <TimeRange color={__color} begin={begin} end={end} mode={mode} />
                </div>

                {expanded ? (
                    <div className="live-annotation__expanded-content" style={{ marginTop: '10px' }}>
                        <div className="live-annotation__message mt-15">
                            <div className="live-annotation__title">{i18n('Note text')}</div>
                            <p>{message || 'Missing message'}</p>
                        </div>
                    </div>
                ) : (
                    <div className="live-annotation__message-preview">{this.getMessagePreview(event.message)}</div>
                )}
            </div>
        )
    }
}

export default DefaultAnnotation
